import axios from 'axios';
import { API_ENDPOINTS } from 'services/api';

export interface UploadSharepointForm {
  sharepointToken: string;
  folderName: string;
  fileName: string;
  fileBase64: string;
}
export interface ILoginBeelajarFormData {
  wstoken: string;
  wsfunction: string;
  moodlewsrestformat: string;
  'user[email]': string;
}
const defaultLoginBeelajarFormData: ILoginBeelajarFormData = {
  wstoken: 'debe7c9be57e4ddadbcf51fca9e9ba64',
  wsfunction: 'auth_userkey_request_login_url',
  moodlewsrestformat: 'json',
  'user[email]': ''
};

export const beelajarService = {
  loginBeelajarService: async (data: { email: string; isSecondRequest?: boolean }) => {
    const params = new URLSearchParams({
      ...defaultLoginBeelajarFormData,
      'user[email]': data.email
    });

    const response = await axios.post(API_ENDPOINTS.BEELAJAR.LOGIN, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
    return response;
  }
};
